import { useAxiosWrapper } from '../../services/axiosWrapper';
import { useBaseOneActions } from '../base.actionsOne';

function useRedefinirSenhaActions() {
  const baseActions = useBaseOneActions('redefinicaoSenha');
  const axiosWrapper = useAxiosWrapper();

  return {
    create: baseActions.create,
    update: updatePassword,
    get: baseActions.get,
  };

  async function updatePassword(id: string, obj: object | any) {
    const recurso = await axiosWrapper.put(
      `${process.env.REACT_APP_API_URL}/v1/redefinicaoSenha/${id}`,
      obj
    );
    return recurso;
  }
}

export { useRedefinirSenhaActions };
